import { render } from "./PrivacyPolicy.vue?vue&type=template&id=706fd0a8&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=706fd0a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706fd0a8"]])

export default __exports__